import { render, staticRenderFns } from "./ChainAgentList.vue?vue&type=template&id=4d99a236"
import script from "./ChainAgentList.vue?vue&type=script&lang=js"
export * from "./ChainAgentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports